import { getAsset } from './prepare-assets';

export const readAsArrayBuffer = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsArrayBuffer(file);
    });
};

export const readAsImage = (src) => {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve(img);
        img.onerror = reject;
        if (src instanceof Blob) {
            const url = window.URL.createObjectURL(src);
            img.src = url;
        } else {
            img.src = src;
        }
    });
};

export const readAsDataURL = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
};

// interface PDF {
//   numPages: number;
//   getPage: (index: number) => Promise<any>;
// }
export const readAsPDF = async (file) => {
    const pdfjsLib = await getAsset('pdfjsLib');
    // Safari possibly get webkitblobresource error 1 when using origin file blob
    const blob = new Blob([file]);
    const url = window.URL.createObjectURL(blob);
    return pdfjsLib.getDocument(url).promise;
};
